import React from 'react'
import {Input, Table, Grid, Row, Col} from 'react-bootstrap'
import axios from 'axios';
import {request} from '../helpers/request'
import {t} from '../helpers/translate.js'
import {isAgent, isGroupAdmin, isSuperAdmin, isMasterAdmin, isAdmin} from '../helpers/access'
import LoadingComponent from './common/LoadingComponent'
import FileInputComponent from './common/FileInputComponent.js';

let config = require('config');

class Commissions extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      filesStatus: [],
      processing: false,
      agentCommissions: null,
      agentId: this.setAgentId(),
      openFolder: null
    };
  }

  componentWillMount() {
    if(this.isUserAllowed()) {
      this.getCommissions();
    }
  }

  isUserAllowed() {
    return isAgent() || isGroupAdmin() || isAdmin('msg');
  }

  setAgentId() {
    return this.isUserAllowed() ? sessionStorage.getItem('user_id') : ''; 
  }

  handleFileSelection(event) {
    event.preventDefault();
    let files = event.target.files
    this.setState({filesStatus: this.getFilesArray()})
  }

  getFilesArray() {
  	let files = [];
  	Object.values(this.uploadInput.files).forEach(file => {
  		const status = {filename: file.name, status: 'Pending'}
  		files.push(status)
    });

    return files;
  }

  handleUploads = (ev) => {
  	this.setState({processing: true});

    let data = {fileNames:[]};

    Object.values(this.uploadInput.files).forEach(file => {
      data.fileNames.push(file.name)
    });

    request(`${config.default.api}/uploadCommissions`,
      'POST',
      data,
      function (responseData, status) {
        if (status == 200) {
          this.uploadFiles(responseData);
          this.uploadInput.value = '';
          event.preventDefault();
        } else {
          this.props.showModal('Error', 
            <div>
              {data.messages.map((message) => <p>{t(message)}</p>)}
            </div>
          );
          event.preventDefault();
        }
      }.bind(this),
      { 'Content-Type': 'application/json'}
    );
  }

  getCommissions = (ev) => {
    this.setState({processing: true});

    request(`${config.default.api}/getCommissions/${this.state.agentId}`,
      'GET', null,
      function (responseData, status) {
        this.setState({processing: false}); 
        if (status == 200) {
          this.setState({agentCommissions: responseData})
          event.preventDefault();
        } else {
          this.props.showModal('Error', 
            <div>
              {data.messages.map((message) => <p>{message}</p>)}
            </div>
          );
          event.preventDefault();
        }
      }.bind(this),
      { 'Content-Type': 'application/json'}
    );
  }

  uploadFiles(data) {
    Object.entries(this.uploadInput.files).forEach(([key,file]) => {
      this.uploadToS3(file, data[key])
    })
    this.setState({processing: false}); 
  }

  uploadToS3(file, signedRequest) {
    const options = {
      headers: {
        'Content-Type': 'pdf',
      }
    };

    axios.put(signedRequest, file, options)
    .then(result => {
    	this.markFilesAsUploaded(file)
    })
  }

  markFilesAsUploaded(file) {
  	let filesStatus = this.state.filesStatus;
  	let foundIndex = filesStatus.findIndex(x => x.filename === file.name)
  	filesStatus[foundIndex].status = 'Complete';
  	this.setState({filesStatus: filesStatus})
  }

  updateAgentId(value) {
    this.setState({agentId: value});
  }

  pageTitle() {
    return isAgent('ingle') ? t('Your Agent Statements') : t('Commissions');
  }

  render() {
    const commissions = this.state.agentCommissions;
    const currentYear = new Date().getFullYear().toString();

    let currentFiles = [];
    let archives = {};
    let archiveYears = [];

    if (commissions && commissions.length > 0) {
      commissions.forEach((file) => {
        const year = file.file.split('-')[1];
        if (year === currentYear) {
          currentFiles.push(file);
        } else {
          if (!archives[year]) archives[year] = [];
          archives[year].push(file);
        }
      });
      archiveYears = Object.keys(archives).sort((a, b) => b - a);
    }

    return (<div className="container">
    	<h2 className='page-title row div-center'>{this.pageTitle()}</h2>
    	<br />

      {((isSuperAdmin() || isMasterAdmin()) && !this.isUserAllowed()) &&
        <div className='section_container'>
          <h4 className="div-center"><b>{t('Upload Files')}</b></h4>
          <FileInputComponent
            onUpload={this.handleFileSelection.bind(this)}
            inputRef={(ref) => { this.uploadInput = ref; }}
          />
          <h4 className="div-center">{t('Files to Upload')}</h4>
          <Grid fluid>
          {this.state.filesStatus.map((file, index) => {
            return (
              <Row>
                  <Col sm={6}>{file.filename}</Col>
                  <Col sm={6}>{file.status}</Col>
              </Row>
            )
              })}
          </Grid>
          <br />
          <div className="div-center">          
            <button 
              className="btn button-secondary" 
              onClick={this.handleUploads.bind(this)} 
            >
            {t('Initiate Uploads')}
            </button>
          </div>
        </div>
      }

      <div className='section_container div-center'>
        {!this.isUserAllowed() &&
          <div>
            <h4 className="div-center"><b>{t('View Commission Statements')}</b></h4>

            <Input
              placeholder={t('Agent ID')}
              type='text'
              onChange={(event) => {this.updateAgentId(event.target.value)}}
            />

            <br />

            {this.state.agentId === '' ?
              null :
              <div className="div-center">          
                <button 
                  className="btn button-secondary" 
                  onClick={this.getCommissions.bind(this)} 
                >
                {t('View Commissions')}
                </button>
              </div>
            }
          <br />
          </div>
        }

        {
          this.state.agentCommissions === null ?
            null
            :
            <div>
              <h4 className="div-center">{t('Agent Commission Statements')}</h4>
              {
                this.state.agentCommissions.length == 0 ?
                  <span>{t('No statements found')}</span>
                  :
                  <Grid fluid className="archive-manager">
                    {currentFiles.map(function (file, i) {
                      return (
                        <Row key={'cur-' + i} className="file-link-row">
                          <Col sm={12}>
                            <a target="_blank" href={file.link}>{file.file}</a>
                          </Col>
                        </Row>
                      );
                    })}

                    {archiveYears.map((year) => {
                      const isOpen = this.state.openFolder === year;

                      return (
                        <div key={year} className="archive-folder">
                          <Row
                            className="folder-header"
                            onClick={() => this.setState({ openFolder: isOpen ? null : year })}
                          >
                            <Col sm={12}>
                              {isOpen ? '▼' : '►'} {year} {t('Archive')}
                            </Col>
                          </Row>

                          {isOpen && archives[year].map((file, i) => {
                            return (
                              <Row key={'arc-' + i} className="archive-file-row">
                                <Col sm={12}>
                                  <a target="_blank" href={file.link}>{file.file}</a>
                                </Col>
                              </Row>
                            );
                          })}
                        </div>
                      );
                    })}
                  </Grid>
              }
            </div>
        }
      </div>

	    <LoadingComponent show={this.state.processing} text='Processing Request'/>
      </div>
    )
  }
}
Commissions.displayName = 'Commissions';
export default Commissions;



// WEBPACK FOOTER //
// ./src/components/Commissions.js